/**
 * Scrolls to the first visible validation message, offset by 200px to account for the page header. No scrolling
 * occurs if the message is already in view. The field with an error message will also receive focus.
 */
export function scrollToMessage(querySelector) {
	const validationMessageSelector = querySelector || '.validation-message:not(.hidden)';
	let validationMessage = document.querySelector(validationMessageSelector);
	if (validationMessage) {
		validationMessage.scrollIntoView({ block: "center" });
	}

	let firstErrorElement = document.querySelector('.has-error input, .has-error select');
	if (firstErrorElement) {
		firstErrorElement.focus();
	}
}
